import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

export const DragIndicator = () => (
  <p className="text-light bg-secondary/90 absolute left-0 top-0 z-20 flex size-full items-center justify-center space-x-2 rounded-lg">
    <Icon size={20} type="20-attachment" />
    <span>{t("tiptap.drag_and_drop_file")}</span>
  </p>
);
